import React from 'react';
import {Container} from '@mui/material';

import './payment.css';
import {useNavigate} from 'react-router-dom';

// Просто обёртка с редиректом. Можно отрефакторить/избавиться
const PaymentPage = () => {
    const navigate = useNavigate();

    setTimeout(() => {
        navigate('/payment/custompayment');
    });

    return (
        <Container sx={{pt: 6, pb: 20}} maxWidth="md">
        </Container>
    );
};

export default PaymentPage;
